import React from 'react';
import RadioPage from '@domain/pages/RadioPage';

const wbfPossible = 'wbfPossible';
function PossibleWBF() {

  const fields = [{
    id: 1,
    value: 'yes',
    triggerKeys: [106, 74, 49],
    label: 'Ja'
  }, {
    id: 2,
    value: 'no',
    triggerKeys: [110, 78, 50],
    label: 'Nee'
  }
  ]

  return <RadioPage fieldName={wbfPossible} styleLabel={'possibleWBF'} fields={fields} />
}

export default PossibleWBF;